import { useEffect, useState } from "react";

// use global variables
let aiModel = "gpt-4o";
let observers = [];

// changes global aiModel state and updates all observers
export const setAiModel = (model) => {
  aiModel = model;
  observers.forEach((update) => update(aiModel));
};

// React Hook
export const useAiModel = () => {
  const [aiModelState, setAiModelState] = useState(aiModel);

  useEffect(() => {
    // add setAiModelState to observers list
    observers.push(setAiModelState);

    // update aiModelState with latest global aiModel state
    setAiModelState(aiModel);

    // remove this setAiModelState from observers, when component unmounts
    return () => {
      observers = observers.filter((update) => update !== setAiModelState);
    };
  }, []);

  // return global aiModel state and setter function
  return [aiModelState, setAiModel];
};
